import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["view", "form"];

  toggle() {
    this.formTarget.classList.toggle("d-none");
  }

  collapse() {
    this.formTarget.classList.add("d-none");
  }
}
